import axiosInstance from "../../../../../axiosInstance";
import {
  success,
  error,
  info,
  warning,
} from "../../../../../store/notification/actions";
import {
  GetCaptureGoods,
  ScanCaptureGoods,
} from "../../CaptureReceivedGoods/helper/CaptureReceivedGoodsHelper";

export async function addPhysicalInventory(data) {
  info("Saving Capture Goods ...");
  if (data != null) {
    return axiosInstance
      .post("/inventory/addPhysicalInventory", {
        barcode: data.barcode,
        upc: data.upc,
        ndc: data.ndc,
        name: data.name,
        strength: data.strength,
        dosageform: data.dosageform,
        packsize: data.packsize,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          data.captureGoodsState.barcode = data.barcode;
          return ScanCaptureGoods(data.captureGoodsState)
            .then((captureGoodsResponse) => {
              success("Saved successfully, please re-scan.");
              return captureGoodsResponse;
            })
            .catch((err) => {
              error(err.response.error[0].message);
              return err.response;
            });
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addPhysicalInventoryManualRx(data) {
  info("Saving Physical Inventory - Manual Rx ...");
  if (data != null) {
    return axiosInstance
      .post("/inventory/addPhysicalInventory", {
        barcode: data.barcode,
        upc: data.upc,
        ndc: data.ndc,
        name: data.name,
        strength: data.strength,
        dosageform: data.dosageform,
        packsize: data.packsize,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Manual Rx product saved successfully, please re-scan.");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addPhysicalInventoryOtcRxProduct(data) {
  info(`Saving record ...`);
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/addPhysicalInventoryOtcRxProduct", {
        user_id: data.user_id,
        store_id: data.store_id,
        upc: data.upc,
        location: data.location,
        sno: data.serialno,
        expiry_date: data.expirydate,
        lot: data.lot,
        quantity: data.qty,
        description: data.description,
        ndc: data.ndc,
        packsize: data.packsize,
        labeller_name: data.labeller_name,
        comments: data.comments,
        inv_type: data.inv_type || "FULL", // default
      })
      .then((response) => {
        success(
          `Physical Inventory ${
            data.Otc ? "OTC" : "RX"
          } product created successfully !!!`
        );
        return response.data.data;
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addPhysicalInventoryOtcRxProductWithoutLotNo(data) {
  info(`Saving record ...`);
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/addPhysicalInventoryOtcRxProductWithoutLotNo", {
        user_id: data.user_id,
        store_id: data.store_id,
        upc: data.upc,
        location: data.location,
        sno: data.serialno,
        expiry_date: data.expirydate,
        lot: data.lot,
        quantity: data.qty,
        description: data.description,
        ndc: data.ndc,
        packsize: data.packsize,
        labeller_name: data.labeller_name,
        comments: data.comments,
        inv_type: data.inv_type || "FULL", // default
      })
      .then((response) => {
        success(
          `Physical Inventory ${
            data.Otc ? "OTC" : "RX"
          } product created successfully !!!`
        );
        return response.data.data;
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

const formatDate = (date) => {
  return date != null
    ? date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
    : null;
};

export async function addOtcProduct(data) {
  info("Saving Capture Goods - OTC ...");
  if (data != null) {
    return axiosInstance
      .post("/inventory/addOtcProduct", {
        user_id: data.captureGoodsState.user_id,
        store_id: data.captureGoodsState.store_id,
        tote_number: data.captureGoodsState.tote_number,
        supplier: data.captureGoodsState.supplier,
        supplier_id: data.captureGoodsState.selectedSupplier.id,
        load_date: data.captureGoodsState.load_date,
        upc: data.upc,
        serialno: data.serialno,
        expirydate: formatDate(data.expirydate),
        lot: data.lot,
        qty: data.qty,
        description: data.description,
        ndc: data.ndc,
        packsize: data.packsize,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("OTC product created successfully !!!");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addRxProduct(data) {
  info("Saving Capture Goods - Rx ...");
  if (data != null) {
    return axiosInstance
      .post("/inventory/addRxProduct", {
        user_id: data.captureGoodsState.user_id,
        store_id: data.captureGoodsState.store_id,
        tote_number: data.captureGoodsState.tote_number,
        supplier: data.captureGoodsState.supplier,
        supplier_id: data.captureGoodsState.selectedSupplier.id,
        load_date: data.captureGoodsState.load_date,
        upc: data.upc,
        serialno: data.serialno,
        expirydate: formatDate(data.expirydate),
        lot: data.lot,
        qty: data.qty,
        description: data.description,
        ndc: data.ndc,
        packsize: data.packsize,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Rx product created successfully !!!");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addOtcManualProduct(data) {
  info("Saving Capture Goods - OTC Manual ...");
  if (data != null) {
    return axiosInstance
      .post("/inventory/addOtcManualProduct", {
        store_id: data.captureGoodsState.store_id,
        upc: data.upc,
        ndc: data.ndc,
        strength: data.strength,
        description: data.description,
        manufacturename: data.manufacturename,
        nonreturnable: data.nonreturnable,
        formula: data.formula,
        dcqty: data.dcqty,
        packsize: data.packsize,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("OTC Manual product created successfully, please re-scan.");
          GetCaptureGoods(
            data.captureGoodsState.user_id,
            data.captureGoodsState.store_id
          ).then((gridResponse) => {
            if (
              gridResponse &&
              gridResponse.data &&
              gridResponse.data.status === "success"
            ) {
              return gridResponse.data.data;
            } else {
              return "";
            }
          });
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function getPhysicalInventoryDetailsFromBarcode(data) {
  info("Getting Details from barcode ...");
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/getPhysicalInventoryDetailsFromBarcode", {
        store_id: data.store_id,
        user_id: data.user_id,
        barcode: data.barcode,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Barcode Scanned successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function getUPCdetailPhysicalInventory(store_id) {
  info("Refreshing ...");
  if (store_id != null) {
    return axiosInstance
      .post("/physicalInventory/getUPCdetailPhysicalInventory", {
        store_id: store_id,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success(response?.data?.data[0]?.fn_getupcdetails_int);
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function getPhysicalInventories_with_lot_no(data) {
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/getPhysicalInventories_with_lot_no", {
        store_id: data.store_id,
        user_id: data.user_id,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Records Loaded Successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          warning("No records found !!!");
          return { message: "No records found.", hasError: true, data: "" };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function getPhysicalInventories_without_lot_no(data) {
  info("Loading ...");
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/getPhysicalInventories_without_lot_no", {
        store_id: data.store_id,
        user_id: data.user_id,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Records Loaded Successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          warning("No records found !!!");
          return { message: "No records found.", hasError: true, data: "" };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addNewPhysicalInventory(data) {
  info("Saving Physical Inventory ...");
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/addPhysicalInventory", {
        store_id: data.store_id,
        user_id: data.user_id,
        location: data.location,
        barcode: data.barcode,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Record saved successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function addPhysicalInventoryWithoutLotNo(data) {
  info("Saving Physical Inventory ...");
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/addPhysicalInventoryWithoutLotNo", {
        store_id: data.store_id,
        user_id: data.user_id,
        location: data.location,
        barcode: data.barcode,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Record saved successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function editPhysicalInventory(data) {
  info("Saving Physical Inventory ...");
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/editPhysicalInventory", {
        store_id: data.store_id,
        user_id: data.user_id,
        ndc: data.ndc,
        upc: data.upc,
        packs: data.packs.toString(),
        loose_qty: data.looseQty,
        comments: data.comments,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Record updated successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// delete physical inventory

export const deletePhysicalInventory = async (data) => {
  info("Deleting Records ...");
  return axiosInstance
    .post("/physicalInventory/deletePhysicalInventory", {
      store_id: data.store_id,
      user_id: data.user_id,
      ndc: data.ndc,
      upc: data.upc,
      lot: data.lot,
    })
    .then((response) => {
      if (response.data.status === "success") {
        success("Records deleted successfully");
        return { message: "", hasError: false, data: response.data.data };
      } else {
        error("Could not complete record deletion.");
        return { message: "", hasError: true, data: "" };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

export const deletePhysicalInventoryWithoutLot = async (data) => {
  info("Deleting Records ...");
  return axiosInstance
    .post("/physicalInventory/deletePhysicalInventoryWithoutLot", {
      store_id: data.store_id,
      user_id: data.user_id,
      ndc: data.ndc,
      upc: data.upc,
    })
    .then((response) => {
      if (response.data.status === "success") {
        success("Records deleted successfully");
        return { message: "", hasError: false, data: response.data.data };
      } else {
        error("Could not complete record deletion.");
        return { message: "", hasError: true, data: "" };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

// Submit Physical Inventory

export async function submitPhysicalInventory(data) {
  info("Submitting Physical Inventories ...");
  if (data != null) {
    return axiosInstance
      .post("/physicalInventory/submitPhysicalInventory", {
        store_id: data.store_id,
        user_id: data.user_id,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("Records submitted successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// Delete Physical Inventory
export async function DeletePhysicalInventoryStage(data) {
  if (data) {
    return await axiosInstance
      .post("/physicalInventory/deletePhysicalInventoryStage", {
        user_id: data.user_id,
        store_id: data.store_id,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("New session created Successfully");
          if (response.data.data && response.data.data.length > 0) {
            return response.data.data;
          } else {
            return [];
          }
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// Update location in physical inventory
export async function UpdateStagePhysicalInventory(data) {
  info("Update Physical Inventories ...");
  if (data != null) {
    if (!data.location) {
      error("Location can't be empty");
    }
    return await axiosInstance
      .post("/physicalInventory/updateStagePhysicalInventory", {
        user_id: data.user_id,
        store_id: data.store_id,
        location: data.location,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Physical Inventories Updated Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// Update comments against ndc in Physical Inventory table
export async function UpdateCommentsPhysicalInventory(data) {
  info("Updating Comment...");
  if (data != null) {
    if (!data.comment) {
      error("Comment should not be empty");
      return;
    }
    return await axiosInstance
      .post("/physicalInventory/updateCommentsPhysicalInventory", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
        comment: data.comment,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success(response.data.data[0].message);
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// get comments for a NDC from Physical Inventory table
export async function GetCommentsPhysicalInventory(data) {
  info("Loading Comment..");
  if (data != null) {
    return await axiosInstance
      .post("/physicalInventory/getCommentsPhysicalInventory", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Loaded Comments");
          return response.data.data;
        } else {
          success("No comments Found. Add New");
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

